module.exports = __webpack_public_path__ + "img/0.dbfeed26.jpg";